import { createStore } from "vuex";
import auth from "./modules/auth";
import user from "./modules/user";

/**
 * code for persisting state info not being used as session management is risky
 */
import createPersistedState from "vuex-persistedstate";
import * as CryptoJS from "crypto-js";

function Encrypt(data) {
  const secret = JSON.stringify(data);
  const passphrase = process.env.VUE_APP_SECRET_KEY || "dfv9345rjMCKHSMbIrbTs23ef";
  const encrypted = CryptoJS.AES.encrypt(secret, passphrase).toString();
  return encrypted;
}
function Decrypt(encrypted) {
  try {
    const passphrase = process.env.VUE_APP_SECRET_KEY || "dfv9345rjMCKHSMbIrbTs23ef";
    const bytes = CryptoJS.AES.decrypt(encrypted, passphrase);
    if (bytes.sigBytes === 0) {
      return null; // Decryption failed
    }
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (error) {
    console.error('Decryption error:', error);
    return null; // Handle decryption error
  }
}

const persistedState = createPersistedState({
  key: "rocketfuel",
  storage: window.sessionStorage,
  getState: (key) => {
    const encryptedData = localStorage.getItem(key);
    return encryptedData ? Decrypt(encryptedData) : null;
  },
  setState: (key, state) => {
    localStorage.setItem(key, Encrypt(state));
  },
});

const store = createStore({
  state: {
    layout: "default-layout",
  },
  mutations: {
    setLayout(state, layout) {
      state.layout = layout;
    },
  },
  getters: {
    layout: (state) => state.layout,
  },
  actions: {},
  modules: {
    auth,
    user,
  },
  // plugins: [persistedState],
});

export default store;
